import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';

const SiAtlassian = React.forwardRef(function SiAtlassian2({ title = "Atlassian", color = "currentColor", size = 24, ...others }, ref) {
  if (color === "default") {
    color = "#0052CC";
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref,
      ...others,
      children: [
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("path", { d: "M7.12 11.084a.683.683 0 00-1.16.126L.075 22.974a.703.703 0 00.63 1.018h8.19a.678.678 0 00.63-.39c1.767-3.65.696-9.203-2.406-12.52zM11.434.386a15.515 15.515 0 00-.906 15.317l3.95 7.9a.703.703 0 00.628.388h8.19a.703.703 0 00.63-1.017L12.63.38a.664.664 0 00-1.196.006z" })
      ]
    }
  );
});
const SiAtlassian$1 = SiAtlassian;

export { SiAtlassian$1 as default };
